import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      period: state => state.stats.period,
      period_from: state => state.stats.period_from,
      period_to: state => state.stats.period_to
    })
  },

  watch: {
    'period': function () {
      this.refreshData();
    },
    'period_from': function () {
      this.refreshData();
    }
  },

  methods: {
    refreshData () {
      if (this.fetchData) {
        this.fetchData();
      }
    }
  }
};
